module.exports = __webpack_public_path__ + "img/integracion-de-soluciones-services.17d2c156.jpg";